import Icon from 'veui/components/Icon'
import { IconFullSquare } from 'dls-icons-vue'

Icon.register('full-square', IconFullSquare)
